import React from "react";

/**
 * Reusable horizontal tab bar.
 *
 * Props:
 *   tabs        – array of { key: string, label: string, icon?: string (FA class e.g. "fa-edit") }
 *   activeTab   – key of the currently active tab
 *   onTabChange(key) – called when a tab is clicked
 *   className   – extra class on the wrapper (e.g. "cms-page-tabs" for content pages)
 */
export default function TabsWidget({ tabs, activeTab, onTabChange, className = "" }) {
  return (
    <div className={`widget-tabs${className ? ` ${className}` : ""}`}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={`${tab.label=='کوردی' ? "kfont" : ""} widget-tab-btn${activeTab === tab.key ? " active" : ""}`}
          onClick={() => onTabChange(tab.key)}
          type="button"
        >
          {tab.icon && <i className={`fa ${tab.icon} tab-icon`} />}
          {tab.label}
        </button>
      ))}
    </div>
  );
}
